import moment from 'moment';
import UuidEncoder from 'uuid-encoder';

export class Solicitud {

    created_at: string;
    flow_id: string;
    flow_name: string;
    has_documents: boolean;
    job_id: any[];
    person_id: string;
    person_name: string;
    request_id: string;
    status_code: string;
    status_message: string;
    updated_at: string;
    user_id: string;
    user_name: string;
    widget_url: string;

    constructor() {
        this.status_code = 'created';
    }
}

function uuidv4Aux() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

